type BackgroundStyle = {
  gradientStartColor: string;
  gradientEndColor: string;
}

export async function generateQrCanvas(svgElement: SVGElement, username: string, backgroundStyle: BackgroundStyle): Promise<Blob | null> {
  const svgUrl = createSvgUrl(svgElement)
  const image = await loadImage(svgUrl)

  const canvas = createCanvas(780, 1318)
  const ctx = canvas.getContext("2d")
  if (!ctx) return null

  drawBackground(ctx, canvas.height, backgroundStyle.gradientStartColor, backgroundStyle.gradientEndColor)
  const { qrX, qrY, qrSize, containerX, containerY, containerSize } = computeQrLayout(canvas.width, canvas.height)

  drawQrContainer(ctx, containerX, containerY, containerSize)
  ctx.drawImage(image, qrX, qrY, qrSize, qrSize)
  drawUsername(ctx, username, canvas.width / 2, containerY + containerSize + 20)

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      URL.revokeObjectURL(svgUrl)
      resolve(blob)
    }, "image/png")
  })
}

function createSvgUrl(svgElement: SVGElement): string {
  const serializer = new XMLSerializer()
  const svgString = serializer.serializeToString(svgElement)
  const blob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" })
  return URL.createObjectURL(blob)
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

function createCanvas(width: number, height: number): HTMLCanvasElement {
  const canvas = document.createElement("canvas")
  canvas.width = width
  canvas.height = height
  return canvas
}

function drawBackground(ctx: CanvasRenderingContext2D, height: number, gradientStartColor: string, gradientEndColor: string) {
  const gradient = ctx.createLinearGradient(0, 0, 0, height)
  gradient.addColorStop(0, gradientStartColor)
  gradient.addColorStop(1, gradientEndColor)
  ctx.fillStyle = gradient
  ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)
}

function computeQrLayout(canvasWidth: number, canvasHeight: number) {
  const qrSize = Math.min(canvasWidth - 200, 440)
  const padding = 10
  const containerSize = qrSize + padding * 2

  const qrX = (canvasWidth - containerSize) / 2 + padding
  const qrY = (canvasHeight - containerSize) / 2 - 40 + padding

  const containerX = qrX - padding
  const containerY = qrY - padding

  return { qrX, qrY, qrSize, containerX, containerY, containerSize }
}

function drawQrContainer(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number = width + 50) {
  ctx.fillStyle = "#FCF9FF1A"
  drawRoundedRect(ctx, x, y, width, height, 8)
}

function drawUsername(ctx: CanvasRenderingContext2D, username: string, x: number, y: number) {
  ctx.font = "normal 36px 'IRANSans', sans-serif"
  ctx.fillStyle = "#FFFFFF"
  ctx.textAlign = "center"
  ctx.fillText(`@${username}`, x, y)
}

function drawRoundedRect(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: number) {
  ctx.beginPath()
  ctx.moveTo(x + radius, y)
  ctx.lineTo(x + width - radius, y)
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
  ctx.lineTo(x + width, y + height - radius)
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
  ctx.lineTo(x + radius, y + height)
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
  ctx.lineTo(x, y + radius)
  ctx.quadraticCurveTo(x, y, x + radius, y)
  ctx.closePath()
  ctx.fill()
}
